import { createContext, type PropsWithChildren, use, useMemo } from 'react';
import type { UserSchema } from '@shape-construction/api/src-global/types';

type SessionContext = {
  user: UserSchema | undefined;
};

const sessionContext = createContext<SessionContext | undefined>(undefined);

export const useSession = () => {
  const ctx = use(sessionContext);
  if (!ctx) throw new Error('Cannot use useSession outside of SessionProvider');

  return ctx;
};

type SessionProviderProps = {
  user: UserSchema | undefined;
};

export const SessionProvider = ({ user, children }: PropsWithChildren<SessionProviderProps>) => {
  const value = useMemo(
    () => ({
      user,
    }),
    [user]
  );
  return <sessionContext.Provider value={value}>{children}</sessionContext.Provider>;
};
